/** Joins items the way the locale writes a list: "English and Swedish" in en-US, "a og b" in nb-NO. */
export const formatList = (items: readonly string[], locale: string): string =>
  new Intl.ListFormat(locale, { type: 'conjunction' }).format(items);

/** Names language codes ("en-us", "sv") in `locale`'s own language, region dropped: "English and Swedish". */
export const formatLanguageNames = (languageCodes: readonly string[], locale: string): string => {
  const names = new Intl.DisplayNames([locale], { type: 'language' });
  return formatList(
    languageCodes.map((code) => {
      const language = new Intl.Locale(code).language;
      return names.of(language) ?? language;
    }),
    locale
  );
};
